<template>
    <div class="col-md-4">
        <a class="post-cards__card" :class="post.acf.theme_color" :href="post.link">
            <div class="image">
                <div class="card-tags">
                    <div class="card-tags__item" v-for="tax in post.tag">{{ tax }}</div>
                </div>
                <img v-if="post.acf.page_header_image" :src="post.acf.page_header_image.sizes.medium" :alt="post.title.rendered" width="343" height="157" />
                <img v-else-if="post.acf.image" :src="post.acf.image.sizes.medium" :alt="post.title.rendered" width="343" height="157" />
            </div>
            <div class="content">
                <div class="date">{{ getPostDate(post.date) }}</div>
                <h3 class="title" v-html="post.title.rendered"></h3>
                <p v-if="post.acf.subtitle" v-html="post.acf.subtitle"></p>
                <p v-else-if="post.acf.page_header_content.subtitle" v-html="post.acf.page_header_content.subtitle"></p>
            </div>
        </a>
    </div>
</template>


<script>
    import moment from "moment";
    moment.locale('nl');

    export default{
        props: ['post'],

        methods: {

            getPostDate(date) {
                return moment(date).format("LL");
            },
        }
    }
</script>